<template lang="pug">
  .grid-list-tile
    img.tile-item(
      v-for="(item, index) in gridList"
      :src="item.bigImg"
      :key="item.gridName"
      @click="handleTileClick(item, index)"
      v-platform-expose="{ handler: handleTileExpose, data: { item, index } }"
    )
</template>

<script>
import { ParamsUtil } from '@/utils/params';
import SPM from '../../../common/spm';

export default {
  name: 'CashbackGridTile',
  props: {
    gridList: {
      type: Array,
      default: () => [],
    },
  },
  inject: ['cashbackStyleVersion'],
  data() {
    return { };
  },
  methods: {
    handleTileClick(item, index) {
      SPM.clickButton({
        buttonName: 'Welfare_onlineretailers_channel_pic',
        businessInfo: {
          adsource: ParamsUtil.getParam('adsource') || '',
          buyicon_name: item?.gridName || '',
          buyicon_picture: item?.bigImg || '',
          clk_url: item?.link || item?.originUrl || '',
          rankNum: index + 1,
          takeoutTestVersion: this.cashbackStyleVersion(),
        },
      });
      this.$emit('grid-click', item);
    },
    handleTileExpose(_entry, { item, index }) {
      SPM.moduleExpose({
        moduleId: 'Welfare_onlineretailers_channel_pic',
        contentId: 'Welfare_onlineretailers_channel_pic',
        exposureTimes: 1,
        businessInfo: {
          adsource: ParamsUtil.getParam('adsource') || '',
          buyicon_name: item?.gridName || '',
          buyicon_picture: item?.bigImg || '',
          clk_url: item?.link || item?.originUrl || '',
          rankNum: index + 1,
          takeoutTestVersion: this.cashbackStyleVersion(),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.grid-list-tile {
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0.12rem 0;
  height: 1.47rem;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.tile-item {
  align-self: flex-end;
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 1.58rem;
  height: 0.67rem;
  border-radius: 0.08rem;
  margin-bottom: 0.12rem;
  overflow: hidden;

  &:last-of-type {
    margin-bottom: 0;
  }

  &:first-of-type {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    height: 1.47rem;
    margin-bottom: 0;
  }

  &.img {
    width: 100%;
    height: 100%;
    display: block;
    border: none;
    outline: none;
    object-fit: cover;
  }
}
</style>
